<template>
	<div class="generateInvoiceItem">
		<field
				:class-error="isInvalid && !customer_id"
				margin="0"
				label="Customer"
				placeholder="Select customer"
				@updateAutocomplete="onAutocomplete($event, 'customer_id')"
				:autocompleteValue="customer_id"
				:items="customers"
				:isClearable="false"
				is-autocomplete
				is-required
		></field>
		<field
				:class-error="isInvalid && !amount?.toString().trim()"
				margin="0"
				label="Amount"
				placeholder="Enter amount"
				type="number"
				:setInputValue="amount"
				icon="dollar"
				@updateInput="onInput($event, 'amount')"
				is-required
		></field>
		<field
				:class-error="isInvalid && !description?.toString().trim()"
				margin="0"
				label="Description"
				placeholder="Enter description"
				:setInputValue="description"
				@updateInput="onInput($event, 'description')"
				is-textarea
				is-required
		></field>
		<custom-btn
				custom-class="apply iconBtn"
				margin="0"
				height="70px"
				@updateEvent="onDeleteItem()"
				:icon-attrs="{ iconId: 'deleteItem', width: 20, height: 20 }"
		></custom-btn>
	</div>
</template>

<script>
export default {
	name: "GenerateInvoiceItem",
	props: {
		customers: Array,
		item: Object,
		index: Number,
		isInvalid: Boolean,
	},
	data: () => ({
		customer: null,
		customer_id: null,
		amount: null,
		description: null,
	}),
	methods: {
		onInput({ value }, key) {
			this[key] = value;
			const index = this.index;
			this.$emit('updateData', { key, value, index });
		},
		onAutocomplete({ value }, key) {
			if (key === "customer_id") {
				this.customer = value;
				this[key] = value.id;
			}
			this[key] = value?.id || value;
			const modValue = value?.id || value;
			const index = this.index;
			this.$emit('updateData', { key, value: modValue, index });
		},
		onDeleteItem() {
			const item = this.item;
			const index = this.index;
			const customer = this.customer?.value;
			const amount = this.amount;

			this.$emit('updateDeleteItem', { item, index, customer, amount });
		}

	},
	mounted() {
		if (this.item) {
			const {
				customer_id,
				amount,
				description,
			} = this.item;

			this.customer_id = customer_id;
			this.amount = amount;
			this.description = description;
		}
	}
};
</script>

<style scoped lang="scss">
.generateInvoiceItem {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 36px;
	grid-gap: 8px;
}
</style>
